/**
 * @file コンポーネント：執刀医情報 ロジック管理
 */

// ライブラリ読み込み
import React, { useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Surgeon = (props) => {
    /**
     * 執刀医情報モーダルの開閉状態
     */
    const [isShow, setIsShow] = useState(false);

    // Presenterに渡す
    return <Presenter {...props} isShow={isShow} setIsShow={setIsShow} />;
};
